import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import client from '../../api/client';

export const fetchEmailTemplates = createAsyncThunk('emailTemplates/fetch', async () => {
  const r = await client.get('/config/email-templates/');
  return r.data;
});

export const updateEmailTemplate = createAsyncThunk('emailTemplates/update', async ({ id, data }) => {
  const r = await client.patch(`/config/email-templates/${id}/`, data);
  return r.data;
});

export const seedDefaults = createAsyncThunk('emailTemplates/seed', async () => {
  const r = await client.post('/config/email-templates/seed_defaults/');
  return r.data;
});

export const createEmailTemplate = createAsyncThunk('emailTemplates/create', async (data) => {
  const r = await client.post('/config/email-templates/', data);
  return r.data;
});

export const deleteEmailTemplate = createAsyncThunk('emailTemplates/delete', async (id) => {
  await client.delete(`/config/email-templates/${id}/`);
  return id;
});

const emailTemplatesSlice = createSlice({
  name: 'emailTemplates',
  initialState: { list: [], loading: false, error: null },
  reducers: {},
  extraReducers: b => {
    b.addCase(fetchEmailTemplates.pending, s => { s.loading = true; });
    b.addCase(fetchEmailTemplates.fulfilled, (s, a) => { s.loading = false; s.list = Array.isArray(a.payload) ? a.payload : (a.payload.results || []); });
    b.addCase(fetchEmailTemplates.rejected, (s, a) => { s.loading = false; s.error = a.error.message; });
    b.addCase(updateEmailTemplate.fulfilled, (s, a) => {
      s.list = s.list.map(t => t.id === a.payload.id ? a.payload : t);
    });
    b.addCase(createEmailTemplate.fulfilled, (s, a) => {
      s.list = [...s.list, a.payload];
    });
    b.addCase(deleteEmailTemplate.fulfilled, (s, a) => {
      s.list = s.list.filter(t => t.id !== a.payload);
    });
  }
});

export default emailTemplatesSlice.reducer;
